module.exports = __webpack_public_path__ + "media/src/images/mails/badge_grade_d-19a70ad834a48ff5a215e5fd1e82a416.png";